import { connect } from "react-redux";

import AdminRoute from "./AdminRoute";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(AdminRoute);
